import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import { useCurrentUser } from "./useCurrentUser";
import { toast } from "sonner";
import type { LoginData } from "../interfaces/login.interface";
import { AxiosError } from "axios";

export const useLogin = () => {
  const { setUser } = useCurrentUser();
  return useMutation({
    mutationFn: async (data: LoginData) => {
      const response = await axiosInstance.post("/auth/login", data);
      return response.data;
    },
    onSuccess: (data) => {
      if (data.rol?.id !== 4) {
        toast.error(
          "Acceso denegado. Esta plataforma es exclusiva para aprendices.",
        );
        return;
      }
      setUser({
        id: data.id,
        nombreUsuario: data.nombreUsuario,
        nombre: data.nombre,
        apellidoPaterno: data.apellidoPaterno,
        apellidoMaterno: data.apellidoMaterno,
        correo: data.correo,
        ultimoAcceso: data.ultimoAcceso,
        rol: {
          id: data.rol.id,
          nombre: data.rol.nombre,
          descripcion: data.rol.descripcion,
        },
      });
      toast.success("¡Inicio de sesión exitoso!");
    },
    onError: (
      error: AxiosError<{ message: string; error: string; statusCode: number }>,
    ) => {
      const errorMessage =
        error?.response?.data?.message || "¡Inicio de sesión fallido!";
      toast.error(errorMessage);
      console.error("Login failed:", error);
    },
  });
};
